import React, { useState, useEffect } from 'react';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import { ToastSuccess, ToastError } from "../../../component/toast-notification";
import { Multiselect } from 'multiselect-react-dropdown';
import {
  addDeHubProduct,
  GetAllDeCategory,
  getSingleDeHubProduct,
  updateDeHubProduct,
  updateDeHubProductImg,
  uploadImage
} from '../../../api/apiService';
import { CategoryOutlined } from '@mui/icons-material';

const DeHubProductForm = () => {
  const location = useLocation();
  const history = useHistory();

  const hubId = new URLSearchParams(location.search).get('hubId');
  const productId = new URLSearchParams(location.search).get('productId');

  const [productData, setProductData] = useState({
    categoryList: [],
    subCategoryList: [],
    product_name: "",
    category: "0",
    subCategory: [],
    local_name: "",
    mrp: "0",
    sellPrice: "0",
    buyPrice: "0",
    tax: "0",
    description: "",
    nutretionalInfo: "",
    qty: "1",
    unit: "",
    minOrderQty: "1",
    maxOrderQty: "10",
    packagingCharge: "0",
    mfgDate:"",
    expiryDate:"",
    images: [],
    rowImage: [],
    nameOfCategory: ""
  });

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const isUpdate = !!productId;

  useEffect(() => {
    if (isUpdate) getSingleDeProductData(hubId, productId);
    getAllDeCategory();
  }, [productId, isUpdate]);

  const handleChange = async (field, value) => {
    setProductData(prev => ({ ...prev, [field]: value }));
    if (field === 'category') {
      if (value === '0') {
        setProductData(prev => ({ ...prev, subCategoryList: [], subCategory: [] }));
      } else {
        const selected = productData.categoryList.find(item => item._id === value);
        if (selected) {
          setProductData(prev => ({ ...prev, subCategoryList: selected.subCategory || [] }));
        }
      }
    }
    if (isSubmitted) validate();
  };
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const imageURLs = files.map(file => URL.createObjectURL(file));

    setProductData(prev => ({
      ...prev,
      images: [...prev.images, ...imageURLs],
      rowImage: [...prev.rowImage, ...files]
    }));

    if (isSubmitted) validate();
  };

  const validate = () => {
  const newErrors = {};

  if (!productData.product_name || productData.product_name.length < 3)
    newErrors.product_name = "Please enter product name (at least 3 characters)";
  if (productData.category === "0")
    newErrors.category = "Please select category";
  if (!productData.subCategory || productData.subCategory.length < 1)
    newErrors.subCategory = "Please select at least one sub-category";
  if (!productData.local_name || productData.local_name.length < 3)
    newErrors.local_name = "Please enter local name (at least 3 characters)";
  if (!productData.mrp)
    newErrors.mrp = "Please enter MRP";
  if (!productData.sellPrice)
    newErrors.sellPrice = "Please enter sell price";
  if (!productData.buyPrice)
    newErrors.buyPrice = "Please enter buy price";
  if (!productData.tax)
    newErrors.tax = "Please enter tax";
  if (!productData.minOrderQty)
    newErrors.minOrderQty = "Please enter min-order quantity";
  if (!productData.maxOrderQty)
    newErrors.maxOrderQty = "Please enter max-order quantity";
  if (!productData.description)
    newErrors.description = "Please enter description";
  if (!productData.mfgDate)
    newErrors.mfgDate = "Please enter manufacturing date";
  if (!productData.expiryDate)
    newErrors.expiryDate = "Please enter expiry date";
  if (!productData.nutretionalInfo)
    newErrors.nutretionalInfo = "Please enter nutritional info";
  if (!productData.images || productData.images.length === 0)
    newErrors.images = "Please select at least one product image";

  setErrors(newErrors);
  Object.values(newErrors).forEach(msg => ToastError(msg));

  return Object.keys(newErrors).length === 0;
};

  const handleProductImage = async (hubId, productId) => {
    if (productData.rowImage?.length > 0) {
      try {
        // for (const file of productData.rowImage) {
        const response = await uploadImage(productData.rowImage, "products");
        const data = response.data.data;
        const imageUrls = Array.isArray(data) ? data.map(img => img.location) : data.location;
        await updateDeHubProductImg(hubId, productId, { images: imageUrls });
        // }
      } catch (error) {
        console.log(error);
      }
    }
    history.goBack();
  };
  const handleRemoveImage = (index) => {
    const newImages = [...productData.images];
    const newRowImages = [...productData.rowImage];
    newImages.splice(index, 1);
    newRowImages.splice(index, 1);
    setProductData(prev => ({
      ...prev,
      images: newImages,
      rowImage: newRowImages
    }));
  };


  const getAllDeCategory = async () => {
    try {
      const response = await GetAllDeCategory();
      setProductData(prev => ({ ...prev, categoryList: response.data.data }));
    } catch (error) {
      console.log(error);
    }
  };

  const getSingleDeProductData = async (hubId, productId) => {
    try {
      const response = await getSingleDeHubProduct(hubId, productId);
      const data = response.data.data;
      setProductData(prev => ({
        ...prev,
        product_name: data.product_name || "",
        subCategory: data.subCategoryIds || [],
        category: data.categoryId?._id || "0",
        nameOfCategory: data.categoryId?.name || "",
        local_name: data.local_name || "",
        qty: data.qty || "1",
        unit: data.unit || "",
        minOrderQty: data.minOrderQty || "1",
        maxOrderQty: data.maxOrderQty || "10",
        mrp: data.mrp || "0",
        buyPrice: data.buyPrice || "0",
        sellPrice: data.sellPrice || "0",
        tax: data.tax || "0", // Fixed: was "tex"
        description: data.description || "",
        nutretionalInfo: data.nutretionalInfo || "",
        packagingCharge: data.packagingCharge || "0",
        mfgDate: data.mfgDate,
        expiryDate: data.expiryDate,
        images: data.images || null
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const submitProduct = async (e) => {
    e.preventDefault();
    const data = {
      product_name: productData.product_name,
      categoryId: productData.category,
      subCategoryIds: productData.subCategory,
      local_name: productData.local_name,
      mrp: productData.mrp,
      sellPrice: productData.sellPrice,
      buyPrice: productData.buyPrice,
      tax: productData.tax,
      description: productData.description,
      nutretionalInfo: productData.nutretionalInfo,
      qty: productData.qty,
      unit: productData.unit,
      minOrderQty: productData.minOrderQty,
      maxOrderQty: productData.maxOrderQty,
      packagingCharge: productData.packagingCharge
    };
    try {
      if (isUpdate) {
        const response = await updateDeHubProduct(hubId, productId, data);
        await handleProductImage(hubId, productId);
        ToastSuccess(response.data.msg);
      } else {
        const response = await addDeHubProduct(hubId, data);
        await handleProductImage(hubId, response.data.data._id);
        ToastSuccess(response.data.msg);
      }
    } catch (error) {
      ToastError(error?.response?.data?.msg || "Something went wrong");
    }
  };

  const handleSubmit = () => {
    setIsSubmitted(true);
    setErrors({});
    if (validate()) submitProduct();
  };
  useEffect(() => {
    if (productData.category !== "0") {
      const selected = productData.categoryList.find(item => item._id === productData.category);
      if (selected) {
        setProductData(prev => ({ ...prev, subCategoryList: selected.subCategory || [] }));
      }
    }
  }, [productData.categoryList, productData.category]);

  const renderInput = (label, field, type = "text", placeholder = "", multiLine = false) => (
    <div className="form-group m-0">
      <label className="font-12 m-0">{label}</label>
      {multiLine ? (
        <textarea
          onChange={(e) => handleChange(field, e.target.value)}
          style={errors[field] ? { border: "1px solid red" } : {}}
          value={productData[field]}
          className="form-control"
          placeholder={placeholder}
          rows={4} // you can adjust this as needed
        />
      ) : (
        <input
          onChange={(e) => handleChange(field, e.target.value)}
          style={errors[field] ? { border: "1px solid red" } : {}}
          type={type}
          value={productData[field]}
          className="form-control"
          placeholder={placeholder}
        />
      )}
      <p className="error-msg mb-3">{errors[field]}</p>
    </div>
  );


  return (
    <>
      <div className="container-fluid add-user-container">
        <h5 className='mt-4 mb-3'>Product Information</h5>
        <div className="row">
          <div className="col-sm-3 col-12">
            {renderInput("Product name", "product_name", "text", "Product Name")}
          </div>
          <div className="col-sm-3 col-12">
            <div className="form-group m-0">
              <label className="font-12 m-0">Category</label>
              <select
                onChange={(e) => handleChange('category', e.target.value)}
                style={errors.category ? { border: "1px solid red" } : {}}
                className="form-control"
                value={productData.category}
              >
                <option value="0">{productData.nameOfCategory || "Select category"}</option>
                {productData.categoryList.map(item => (
                  <option key={item._id} value={item._id}>{item.name}</option>
                ))}
              </select>
              <p className="error-msg mb-3">{errors.category}</p>
            </div>
          </div>
          <div className="col-sm-3 col-12">
            <div className="form-group m-0">
              <label className="font-12 m-0">Sub category</label>
              <div style={errors.subCategory ? { border: "1px solid red", borderRadius: "4px" } : { border: "1px solid #cccccc", borderRadius: "4px" }}>
                {/* <Multiselect
                  onSelect={(selectedList) => handleChange('subCategory', selectedList)}
                  onRemove={(selectedList) => handleChange('subCategory', selectedList)}
                  options={productData.subCategoryList}
                  isObject={true}
                  displayValue="name"
                  placeholder="Select Item"
                  showCheckbox={true}
                  selectedValues={productData.subCategory}
                /> */}
                <Multiselect
                  onSelect={(selectedList) =>handleChange("subCategory",selectedList.map((item) => item._id))}
                  onRemove={(selectedList) =>handleChange("subCategory",selectedList.map((item) => item._id))}
                  options={productData.subCategoryList}
                  isObject={true}
                  displayValue="name"
                  placeholder="Select Item"
                  showCheckbox={true}
                  selectedValues={productData.subCategoryList.filter(sc =>
                    productData.subCategory.includes(sc._id)
                  )}
                />
              </div>
              <p className="error-msg mb-3">{errors.subCategory}</p>
            </div>
          </div>
          <div className="col-sm-3 col-12">
            {renderInput("Local name", "local_name", "text", "Local Name")}
          </div>
        </div>
        <div className='row'>
          <div className="col-sm-3 col-12">
            {renderInput("Quantity", "qty", "number", "Quantity")}
          </div>
          <div className="col-sm-3 col-12">
            {renderInput("Unit", "unit", "text", "Unit (kg, piece, etc.)")}
          </div>
          <div className="col-sm-3 col-12">
            {renderInput("Min order quantity", "minOrderQty", "number", "Min-order quantity")}
          </div>
          <div className="col-sm-3 col-12">
            {renderInput("Max order quantity", "maxOrderQty", "number", "Max-order quantity")}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3 col-12">
            {renderInput("MRP", "mrp", "number", "MRP")}
          </div>
          <div className="col-sm-3 col-12">
            {renderInput("Sell price", "sellPrice", "number", "Sell Price Without tax per Pc")}
          </div>
          <div className="col-sm-3 col-12">
            {renderInput("Buy price", "buyPrice", "number", "Buy Price")}
          </div>
          <div className="col-sm-3 col-12">
            {renderInput("Tax", "tax", "number", "Tax")}
          </div>
        </div>

        <div className="row">
        </div>

        <div className="row">
          <div className="col-sm-3 col-12">
            {renderInput("Packaging charges", "packagingCharge", "number", "Packaging charges")}
          </div>
          <div className="col-sm-6 col-12">
            {renderInput("Nutretional Info", "nutretionalInfo", "text", "Nutretional Info", true)}
          </div>

        </div>

        <div className="row">
          <div className="col-sm-12 col-12">
            {renderInput("Product Description", "description", "text", "Enter description", true)}
          </div>
        </div>
        <div className="col-sm-3 col-12">
          <div className="new-outlet-image-container">
            <label className="font-12 m-0">Product images</label>
            <label className="upload-image-container cursor-pointer" htmlFor="file">
              {productData.images?.length > 0 ? (
                <div className="d-flex flex-wrap gap-2">
                  {productData.images.map((img, i) => (
                    <div key={i} style={{ position: "relative", display: "inline-block" }}>
                      <img
                        src={img}
                        alt={`Product ${i}`}
                        style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "4px" }}
                      />
                      <span
                        onClick={() => handleRemoveImage(i)}
                        style={{
                          position: "absolute",
                          top: "-6px",
                          right: "-6px",
                          background: "#ff4d4f",
                          color: "white",
                          borderRadius: "50%",
                          width: "20px",
                          height: "20px",
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer"
                        }}
                      >
                        ✕
                      </span>
                    </div>
                  ))}
                </div>
              ) : (
                <>
                  <i className="demo-icon icon-camera">&#xe807;</i>
                  <span>Upload images</span>
                </>
              )}
              <input
                type="file"
                id="file"
                accept="image/*"
                multiple
                onChange={handleImageChange}
                style={{ display: 'none' }}
              />
            </label>
            <p className="error-msg mb-3">{errors.images}</p>
          </div>

        </div>
      </div>


      <div className="my-3" style={{ display: "flex", justifyContent: "space-between" }}>
        <button type="button" onClick={() => history.goBack()} className="btn btn-cancel">
          Cancel
        </button>
        <button onClick={(e)=>submitProduct(e)} type="button" className="btn btn-verify">
          {isUpdate ? "Update" : "Add"}
        </button>
      </div>
    </>
  );
};

export default DeHubProductForm;